import { SYSTEM_THEMES } from '@constants/Themes';
import { System } from '@models/System';
import { ROLES as ROLES_VALLADOLID } from './RolesValladolid';
import { ROLES as ROLES_HLMRA } from './RolesHLMRA';
import { ROLES as ROLES_RA } from './RolesRA';

export enum SYSTEMS {
  SALI = 1,
  HLMRA = 2,
  RA = 3,
  VALLADOLID = 4,
};

export const VALLADOLID: System = {
	id: SYSTEMS.VALLADOLID,
	name: 'Valladolid',
	theme: SYSTEM_THEMES.valladolid,
	primaryColor: '#002161',
	login: '/auth/sign-in-valladolid',
  readingPlanNodeId: 3385,
	logoFirst: 'assets/logos/valladolid/logo_valladolid.svg',
	logoSecondary: 'assets/logos/valladolid/logo_multiversidad.svg',
	roles: ROLES_VALLADOLID,
};

export const RA: System = {
	id: SYSTEMS.RA,
	name: 'Recursos Académicos',
	theme: SYSTEM_THEMES.ra,
	primaryColor: '#002161',
	login: '/auth/sign-in-ra',
  readingPlanNodeId: 3531,
	logoFirst: 'assets/logos/ra/logo.svg',
	roles: ROLES_RA,
};

export const HLMRA: System = {
	id: SYSTEMS.HLMRA,
	name: 'HLMRA',
	theme: SYSTEM_THEMES.hlmra,
	primaryColor: '#002161',
	login: '/auth/sign-in-hlmra',
  readingPlanNodeId: 975,
	logoFirst: 'assets/logos/ra/logo.svg',
	roles: ROLES_HLMRA,
};

export const SALI: System = {
	id: SYSTEMS.SALI,
	name: 'SALI',
	theme: SYSTEM_THEMES.sali,
	primaryColor: '',
	login: '/auth/sign-in-sali',
  readingPlanNodeId: 0,
	logoFirst: '',
	roles: []
};